export default "__VITE_ASSET__DcRfzE7D__"